import * as React from 'react'
import { Box, Typography, Button, Divider } from '@mui/material'
import MapContainer from '@components/map/MapContainer'
import EditOutlinedIcon from '@assets/ConsumerDetails/Pen.svg'
import YearComparisonChart from '@/components/charts/YearComparisonChart'
import ReusableInfoCard from '@/components/common/ReusableInfoCard'
import { infoCards } from '@/mockdata/sensors/sensorsDetails'
const SensorDetails: React.FC = () => {
  const RUBIK =
    '"Rubik", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif'
  const BORDER = '#E4E7EB'

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-start',
          py: 2,
        }}
      >
        <Button
          variant="contained"
          sx={{
            bgcolor: '#E3F5FF',
            color: '#003F61',
            borderRadius: 1,
            py: 1,
            border: '1px solid #E4E7EB',
            boxShadow: 'none',
            '&:hover': { bgcolor: '#D8EAFB', boxShadow: 'none' },
            fontWeight: 300,
            width: 145,
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: 14,
          }}
        >
          עריכת פרטים
          <img
            src={EditOutlinedIcon}
            alt="Polyline"
            style={{ width: '17px', height: '17px' }}
          />
        </Button>
      </Box>

      <Box
        sx={{
          width: '100%',
          maxWidth: '100%',
          height: '101vh',
          display: 'flex',
          overflow: 'hidden',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '40%',
            gap: 2,
            justifyContent: 'start',
            alignItems: 'end',
          }}
        >
          {infoCards.map(card => (
            <ReusableInfoCard
              key={card.title}
              title={card.title}
              icon={card.icon}
              items={card.items}
              footerNote={card.footerNote}
            />
          ))}
        </Box>

        <Box
          sx={{
            flex: 1,
            flexDirection: 'column',
            width: '60%',
            alignItems: 'center',
            display: 'flex',
            px: 1,
            gap: 2,
          }}
        >
          <YearComparisonChart
            headerTitle=""
            showCompareLabel={false}
            defaultCompare={false}
            legend={false}
            legend2={false}
            footerItems={[{ label: "", color: "" }]}
            currentYearData={[
              [0, 12],
              [20, 22],
              [40, 35],
              [60, 50],
              [80, 64],
              [100, 78],
              [120, 90],
            ]}
            height={280}
          />

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              justifyContent: 'center',
              px: 2,
              py: 2,
              borderRadius: 1,
              height: 240,
              bgcolor: '#fff',
              border: `1px solid ${BORDER}`,
            }}
          >
            <Typography
              sx={{
                fontFamily: RUBIK,
                fontWeight: 400,
                fontSize: 16,
                lineHeight: 1,
                letterSpacing: 0,
                textAlign: 'end',
                color: '#003F61',
                alignItems: 'center',
              }}
            >
              תצוגה על גבי מפה
            </Typography>
            <Divider sx={{ my: 1 }} />
            <MapContainer interaction="view" />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default SensorDetails
